import React from 'react';
import { Mail, MapPin, Phone } from 'lucide-react';
import { APP_NAME } from '../config/appConfig';
import { useDocumentMetadata } from '../hooks/useDocumentMetadata';

const contactItems = [
  {
    icon: <Mail className="h-5 w-5 text-sky-600" />,
    label: 'Email',
    value: 'team@mediinsightai.dev',
  },
  {
    icon: <Phone className="h-5 w-5 text-sky-600" />,
    label: 'Phone',
    value: '+1 (555) 010-2400',
  },
  {
    icon: <MapPin className="h-5 w-5 text-sky-600" />,
    label: 'Office',
    value: 'Remote-first product studio',
  },
];

const ContactPage: React.FC = () => {
  useDocumentMetadata(
    'Contact',
    `Get in touch with the ${APP_NAME} team for demos, collaboration, or product questions.`
  );

  return (
    <div className="min-h-screen bg-slate-50 py-12">
      <div className="container mx-auto max-w-4xl px-6">
        <div className="rounded-3xl bg-white p-10 shadow-sm ring-1 ring-slate-200">
          <h1 className="text-4xl font-bold text-slate-900">Contact</h1>
          <p className="mt-4 text-lg text-slate-600">
            Reach out for product walkthroughs, technical discussions, or collaboration opportunities around {APP_NAME}.
          </p>

          <div className="mt-8 grid gap-5">
            {contactItems.map((item) => (
              <div key={item.label} className="flex items-center gap-4 rounded-2xl bg-slate-50 p-5">
                {item.icon}
                <div>
                  <p className="text-sm text-slate-500">{item.label}</p>
                  <p className="font-medium text-slate-900">{item.value}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
